/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable eslint-comments/no-duplicate-disable */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable max-lines */
import React, { useState } from 'react'
import StarIcon from '@usap/uicomponents/src/components/Icons/wmo-icons/StarIcon'
import ChevronLeft from '@usap/uicomponents/src/components/Icons/wmo-icons/ChevronLeft'
import ChevronRight from '@usap/uicomponents/src/components/Icons/wmo-icons/ChevronRight'
import QuoteIcon from '@usap/uicomponents/src/components/Icons/wmo-icons/QuoteIcon'
import CheckCircle from '@usap/uicomponents/src/components/Icons/wmo-icons/CheckCircle'
import {
  Content,
  CustomerInfo,
  CustomerName,
  Header,
  NavButton,
  NavigationButtons,
  QuoteIconWrapper,
  RatingContainer,
  Title,
  TrustBannerContainer,
  VerifiedBadge,
} from './TrustBanner.css'
import GTM from '../../helpers/GTM'

// Types
type Testimonial = {
  title: string;
  rating: number;
  customer: {
    name: string;
  };
};

type TrustBannerProps = {
  isEnabled: boolean;
  testimonials: Testimonial[];
  dataTestId?: string;
};

// Main Component
const TrustBanner: React.FC<TrustBannerProps> = ({
  isEnabled,
  testimonials,
  dataTestId,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const showNavigation = Boolean(testimonials?.length > 1)
  const currentTestimonial = testimonials[currentIndex]

  const handlePrevious = () => {
    setCurrentIndex(prevIndex => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1))
    GTM.cartTestimonialCarouselInteraction()
  }

  const handleNext = () => {
    setCurrentIndex(prevIndex => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1))
    GTM.cartTestimonialCarouselInteraction()
  }

  if (!isEnabled || testimonials.length === 0) {
    return null
  }

  return (
    <TrustBannerContainer data-testid={dataTestId || 'trust-banner'}>
      <Header>
        <RatingContainer>
          {[1, 2, 3, 4, 5].map(star => (
            <StarIcon key={star} filled={star <= currentTestimonial.rating} />
          ))}
        </RatingContainer>
        {showNavigation && (
          <NavigationButtons>
            <NavButton
              onClick={handlePrevious}
              aria-label="Previous testimonial"
            >
              <ChevronLeft />
            </NavButton>
            <NavButton onClick={handleNext} aria-label="Next testimonial">
              <ChevronRight />
            </NavButton>
          </NavigationButtons>
        )}
      </Header>

      <QuoteIconWrapper>
        <QuoteIcon />
      </QuoteIconWrapper>

      <Content>
        <Title>{currentTestimonial.title}</Title>
        <CustomerInfo>
          <CustomerName>{currentTestimonial.customer.name}</CustomerName>
          <VerifiedBadge>
            <CheckCircle />
            <span>Verified</span>
          </VerifiedBadge>
        </CustomerInfo>
      </Content>
    </TrustBannerContainer>
  )
}

export default TrustBanner
